<template>
  <modal v-if="voucher" hide-footer size="xl" id="modal-voucher" @close="voucher = null">
    <template #header>
      <h3>Comanda</h3>
    </template>
    <template #body>
      <div v-if="!selectedProduct">
        <h2 class="text-center">
          {{ $t('words.voucher') }} {{ voucher.code }}
        </h2>
        <p style="text-align: center; font-weight: bold">{{ voucher.orderDetail.product.name }}</p>
        <p style="text-align: center">Caduca el día {{ formatDate(toDate(voucher.expiresAt)) }}</p>
        <div v-if="!isExpired()" class="text-center" style="margin-bottom: 30px">
          {{ $t('messages.availableBookings') }}: {{ availableBookings }} de {{ voucher.maximumNumberOfBookings }}<br>
        </div>
        <div v-for="bookingOrderDetail in voucher.bookings" :key="bookingOrderDetail.id" style="text-align: center;">
          Reserva el dia {{ formatDateTime(toDate(bookingOrderDetail.startsAt)) }}
        </div>
        <div v-if="selectedSlot" style="margin-top: 30px;" class="text-center">

          <div style="margin-bottom: 20px"><b>Reservant per la data:</b> {{ formatDateTime(selectedSlot.startDate) }}
          </div>
          <div>
            <div class="form-field">
              <label for="wdgt-notes-field">{{ $t('words.comment') }}</label><br>
              <textarea id="wdgt-notes-field" v-model="notes">
            </textarea>
            </div>
          </div>
          <button type="button" class="secondary" @click="selectedSlot = null" style="margin-right: 30px">
            {{ $t('actions.cancel') }}
          </button>
          <button type="button" @click="sendBooking">
            {{ $t('actions.book') }}
          </button>
        </div>
        <div v-else-if="availableBookings && !isExpired()" class="text-center" style="margin-top: 30px;">
          <button type="button" class="secondary" @click="voucher = null" style="margin-right: 30px">
            {{ $t('actions.cancel') }}
          </button>
          <button type="button" @click="openCalendar">
            {{ $t('actions.book') }}
          </button>
        </div>
        <div v-else-if="isExpired()" class="text-center">
          <p style="font-weight: bold; color: #c91919">VAL CADUCAT EL DIA {{
              formatDate(toDate(voucher.expiresAt))
            }}</p>
          <button type="button" class="secondary" @click="voucher = null">
            {{ $t('actions.cancel') }}
          </button>
        </div>
        <div v-else class="text-center">
          <p style="font-weight: bold; color: #c91919">VAL EXHAURIT</p>
          <button type="button" class="secondary" @click="voucher = null">
            {{ $t('actions.cancel') }}
          </button>
        </div>
      </div>
      <SimpleCalendar v-else :product="selectedProduct" :gift-voucher="voucher"
                      @bookingSlotSelected="handleBookingSlotSelected" @cancel="handleCancel"/>
    </template>
  </modal>
  <div v-else style="text-align: center">
    <div class="wdgt-image-wrapper"/>
    <div class="wdgt-name-coupon">
      <div class="wdgt-name">
        <a class="voucher-show-form" @click.prevent="toggleShowForm">Tens un abonament o un xec regal? Comprova'l
          aquí</a>
      </div>
    </div>
    <div v-show="showForm" class="voucher-form-container">
      <div class="wdgt-description-input">
        <input v-model="voucherCode" type="text" class="voucher-code-check-input" placeholder="Introdueix el codi"
               @keypress.enter="checkVoucher">
      </div>
      <div class="wdgt-buttons">
        <button type="button" class="voucher-code-check-button" @click="checkVoucher">
          COMPROVA
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import GiftVoucherRepository from "@/api/GiftVoucherRepository";
import SimpleCalendar from '@/components/simpleCalendar';
import Modal from '@/components/modal';
import SweetAlert from "sweetalert2";
import {i18n} from "@/lang";
import filterMixin from '@/mixins/filterMixin';

export default {
  mixins: [filterMixin],
  components: {SimpleCalendar, Modal},
  data() {
    return {
      voucher: null,
      voucherCode: null,
      selectedProduct: null,
      selectedSlot: null,
      notes: '',
      showForm: false
    }
  },
  computed: {
    availableBookings() {
      return this.voucher.maximumNumberOfBookings - this.voucher.bookings.length
    }
  },
  methods: {
    async checkVoucher() {
      try {
        if (this.voucherCode.length <= 5) {
          throw true;
        }
        const response = await GiftVoucherRepository.checkVoucher(this.voucherCode)
        this.voucher = response.data;
      } catch (err) {
        await SweetAlert.fire({
          title: this.$t('messages.incorrectCode'),
          html: this.$t('messages.incorrectCodeText'),
          icon: 'info',
          iconColor: '#c91919',
          confirmButtonColor: '#c91919'
        })
      }
    },
    isExpired() {
      return (new Date(this.voucher.expiresAt) <= new Date());
    },
    openCalendar() {
      const product = this.voucher.orderDetail.product;

      // Si el producto es un pack, necesitamos encontrar el producto hijo con bookingCalendarId
      if (product.type === 'pack' && product.packItems && product.packItems.length > 0) {
        // Buscar el primer producto hijo que tenga bookingCalendarId
        const bookableProduct = product.packItems.find(
          item => item.childProduct && item.childProduct.bookingCalendarId
        );

        if (bookableProduct) {
          this.selectedProduct = bookableProduct.childProduct;
        } else {
          // Si no se encuentra producto reservable, mostrar error
          console.error('No se encontró producto reservable en el pack');
          SweetAlert.fire({
            title: this.$t('messages.error'),
            html: 'No se encontró un producto reservable en este vale de regalo',
            icon: 'error'
          });
        }
      } else {
        // Si no es un pack, usar el producto directamente
        this.selectedProduct = product;
      }
    },
    handleBookingSlotSelected(slot) {
      this.selectedSlot = slot
      this.selectedProduct = null
    },
    handleCancel() {
      this.selectedProduct = null
    },
    async sendBooking() {
      await GiftVoucherRepository.bookVoucher(
        this.voucher.code,
        this.selectedSlot.startDate,
        this.notes
      ).then((response) => {
        for (const booking of response.data) {
          this.voucher.bookings.push(booking);
        }
        this.selectedProduct = null;
        this.selectedSlot = null;
        SweetAlert.fire({
          title: this.$t('messages.bookingConfirmed'),
          html: this.$t('messages.bookingIsConfirmedText'),
          icon: 'success'
        })
      }).catch((error) => {
        if (error.response.data.code === 1000007) {
          SweetAlert.fire({
            title: i18n.t('messages.noBookingPossible'),
            html: i18n.t('messages.giftVouchersAreIndividual'),
            icon: 'info'
          });
        } else {
          SweetAlert.fire({
            title: i18n.t('messages.errorTryingToBook'),
            html: i18n.t('messages.errorTryingToBookMessage'),
            icon: 'error'
          });
        }
      })
    },
    toggleShowForm() {
      this.showForm = !this.showForm;
    },
    formatDate(date) {
      const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return new Intl.DateTimeFormat('es-ES', options).format(new Date(date));
    },
    formatDateTime(date) {
      const options = {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'};
      return new Intl.DateTimeFormat('es-ES', options).format(new Date(date));
    }
  }
}
</script>

<style scoped>
button {
  border: none;
  border-radius: 8px;
  color: #fff;
  padding: 6px 12px;
  background: #c91919;
}

button.secondary {
  background: #939393;
}

.voucher-show-form {
  text-decoration: underline;
  cursor: pointer;
}

.voucher-code-check-input {
  margin-top: 20px;
  background-color: transparent !important;
  border: 0;
  border-bottom: 1px solid #3CAADE !important;
  color: #3CAADE !important;
  font-size: 1rem;
  text-transform: uppercase;
}

.voucher-code-check-input::placeholder {
  text-align: center;
}

.voucher-code-check-button {
  background-color: transparent;
  border: 1px solid #000;
  color: #000;
  padding: 6px 12px;
  margin-top: 20px;
  cursor: pointer;
}
</style>
